<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{ $t("Users.UpdateUser") }}
          </h3>
          <CAlert :show.sync="dismissCountDown" color="primary" fade>
            ({{ dismissCountDown }}) {{ message }}
          </CAlert>

          <CRow>
            <CCol col="6">
              <CInput
                :label="$t('Users.Name')"
                type="text"
                v-model="user.name"
                readonly
              ></CInput>
            </CCol>
            <CCol col="6">
              <CInput
                :label="$t('Users.Email')"
                type="text"
                v-model="user.email"
                readonly
              ></CInput>
            </CCol>
          </CRow>
          <CRow>
            <CCol col="6">
              <CSelect
                :label="$t('Users.Title')"
                :value.sync="user.last_subscription.subscription.id"
                :plain="true"
                :options="subscriptions"
              ></CSelect>
              <!-- <CInput
                label="Subscription Title"
                type="text"
                v-model="user.last_subscription.subscription.id"
              ></CInput> -->
            </CCol>
            <CCol col="6">
              <CSelect
                :label="$t('Users.Price')"
                :value.sync="user.last_subscription.subscription.id"
                :plain="true"
                :options="prices"
              ></CSelect>
              <!-- <CInput
                label="Price"
                type="text"
                v-model="user.last_subscription.subscription.price"
              ></CInput> -->
            </CCol>
          </CRow>

          <CInput
            :label="$t('Users.Description')"
            type="text"
            v-model="user.last_subscription.subscription.description"
          ></CInput>

          <CRow>
            <CCol col="6">
              <CInput
                :label="$t('Users.StartDate')"
                type="date"
                v-model="start_date"
              ></CInput>
            </CCol>
            <CCol col="6">
              <CInput
                :label="$t('Users.EndDate')"
                type="date"
                v-model="end_date"
              ></CInput>
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6">
              <CInput
                :label="$t('Users.Delete')"
                type="number"
                v-model="user.last_subscription.subscription.delete_item_after"
              ></CInput>
            </CCol>
          </CRow>

          <CButton color="info" @click="updateUserSub()" class="w-100">{{
            $t("Button.Update")
          }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { userService, subscriptionService } from "../../_services";
export default {
  name: "EditUser",
  data: () => {
    return {
      files: [],
      user: {},
      subscriptions: [],
      prices: [],
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      photos: [],
      product_types: [],
      batches: [],
      colors: [],
      sizes: [],
      brands: [],
      message: "",
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      product_types_full: [],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/users'})
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getFilePath(file) {
      file.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(file.file);
      }
      console.log(
        this.files.map(function(obj) {
          return obj.file;
        })
      );
      return file.blob;
    },
    removePhoto(file) {
      this.files.forEach(
        function(item, i) {
          if (this.files[i].name === file.name) {
            this.files.splice(i, 1);
            return false;
          }
        }.bind(this)
      );
    },
    updateUserSub() {
      let form = new FormData();
      let price = this.prices.find(
        (o) => o.value == this.user.last_subscription.subscription.id
      );
      form.append("shop_user_id", this.user.id);
      form.append(
        "subscription_id",
        this.user.last_subscription.subscription.id
      );
      form.append("start_date", this.start_date);
      form.append("end_date", this.end_date);
      form.append("price", price.label);
      form.append(
        "description",
        this.user.last_subscription.subscription.description
      );

      userService
        .updateUserSub(form)
        .then(
          function(data) {
            this.$toast.success("Produit créé avec succès");
            this.message = "added successfully";
            this.showAlert();
            this.goBack();
          }.bind(this)
        )
        .finally(
          function() {
            this.loader.hide();
          }.bind(this)
        );
    },
    getSubscriptions() {
      let self = this;

      subscriptionService
        .getAll()
        .then(function(response) {
          let subArray = [];
          let subPrices = [];
          response.data.data.forEach((el) =>
            subArray.push({ value: el.id, label: el.title })
          );
          response.data.data.forEach((el) =>
            subPrices.push({ value: el.id, label: el.price })
          );
          self.subscriptions = subArray;
          self.prices = subPrices;
        })
        .finally(function() {}.bind(this));
    },
  },
  mounted() {
    this.getSubscriptions();
    this.loader = this.$loading.show();
    userService
      .getById(this.$route.params.id)
      .then(
        function(response) {
          this.user = response.data;
          this.start_date = response.data.last_subscription.start_date.substr(
            0,
            10
          );
          this.start_time = response.data.last_subscription.start_date.substr(
            11,
            16
          );
          this.end_date = response.data.last_subscription.end_date.substr(
            0,
            10
          );
          this.end_time = response.data.last_subscription.end_date.substr(
            11,
            16
          );
          // this.photos = JSON.parse(response.ad.ad_media);
        }.bind(this)
      )
      .finally(
        function() {
          this.loader.hide();
        }.bind(this)
      );
  },
};
</script>
<style>
.product-preview {
  width: 150px;
  height: 150px;
  float: left;
  background-position: center;
  background-size: 80% 100%;
  background-repeat: no-repeat;
  margin: 5px;
}
select {
  width: 100%;
  height: 25px;
  border: 1px solid #ddd;
  padding-left: 10px;
  border-radius: 5px;
  color: #888;
}
</style>
